<template>
  <div class="other-config">
    <!-- 邮箱配置内容 -->
    <div class="email-config-content">
      <div class="data-section">
          <div class="section-header">
            <div>
              <span style="font-size: 14px; color: #333">邮箱配置</span>
            </div>
          <div class="toolbar">
            <el-button v-if="userRole === 0" type="primary" @click="openAddDialog">新增</el-button>
            
            <!-- 刷新按钮 -->
            <el-button type="text" @click="refreshData">
              <el-icon><Refresh /></el-icon>
            </el-button>

            <!-- 密度设置 -->
            <el-popover
              placement="bottom"
              width="160"
              v-model:visible="densityDialogVisible"
            >
              <div class="popover-content">
                <el-button
                  class="density-button"
                  :type="rowHeight === '80px' ? 'primary' : ''"
                  @click="setRowHeight('80px')"
                >
                  默认
                </el-button>
                <el-button
                  class="density-button"
                  :type="rowHeight === '60px' ? 'primary' : ''"
                  @click="setRowHeight('60px')"
                >
                  中等
                </el-button>
                <el-button
                  class="density-button"
                  :type="rowHeight === '30px' ? 'primary' : ''"
                  @click="setRowHeight('30px')"
                >
                  紧凑
                </el-button>
              </div>
              <template #reference>
                <el-button type="text">
                  <el-icon><Grid /></el-icon>
                </el-button>
              </template>
            </el-popover>

            <!-- 列显示设置 -->
            <el-popover placement="bottom" width="100" v-model:visible="columnsDialogVisible">
              <div class="popover-content">
                <el-checkbox-group v-model="tempSelectedColumns">
                  <el-checkbox
                    v-for="column in columns"
                    :key="column.prop"
                    :label="column.prop"
                  > 
                    {{ column.label }}
                  </el-checkbox>
                </el-checkbox-group>
                <div class="popover-footer">
                  <el-button @click="resetColumns">重置</el-button>
                  <el-button type="primary" @click="confirmColumns">确定</el-button>
                </div>
              </div>
              <template #reference>
                <el-button type="text">
                  <el-icon><Setting /></el-icon>
                </el-button>
              </template>
            </el-popover>
          </div>
        </div>

        <!-- 表格区域 -->
        <el-table
          :data="tableData"
          :row-style="getRowStyle"
          :header-cell-style="{
            background: '#f5f7fa',
            color: '#909399',
            textAlign: 'center',
          }"
          :row-class-name="tableRowClassName"
        >
          <el-table-column
            v-for="column in visibleColumns"
            :key="column.prop"
            :prop="column.prop"
            :label="column.label"
            :min-width="column.minWidth || column.width"
            :align="column.align || 'center'"
          >
            <template #default="scope">
              <template v-if="column.prop === 'operation'">
                <div class="operation-buttons" v-if="userRole === 0">
                  <el-button type="text" style="color: red" @click="deleteEmailConfig(scope.row.email)">
                    删除
                  </el-button>
                  
                  <el-button type="text" style="color: blue" @click="editEmailConfig(scope.row)">
                    编辑
                  </el-button>
                </div>
                <div v-else class="operation-buttons">
                  <span style="color: #909399;">无权限操作</span>
                </div>
              </template>
              <template v-else-if="column.prop === 'password'">
                <span v-if="userRole === 0">{{ scope.row[column.prop] }}</span>
                <span v-else>******</span>
              </template>
              <template v-else-if="column.prop === 'status'">
                <el-tag :type="scope.row[column.prop] === 1 ? 'success' : 'danger'">
                  {{ scope.row[column.prop] === 1 ? '启用' : '禁用' }}
                </el-tag>
              </template>
              <template v-else-if="column.prop === 'createTime'">
                {{ formatDateTime(scope.row[column.prop]) }}
              </template>
              <template v-else>
                {{ scope.row[column.prop] }}
              </template>
            </template>
          </el-table-column>

          <template #empty>
            <div class="empty-state">
              <el-icon class="empty-icon"><Box /></el-icon>
              <p class="empty-text">暂无数据</p>
            </div>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 新增/编辑邮箱配置弹窗 -->
    <el-dialog
      :title="dialogTitle"
      v-model="dialogVisible"
      width="500px"
      class="custom-dialog"
      @close="closeDialog"
    >
      <div class="dialog-content">
        <el-form :model="formData" label-width="120px" :rules="rules" ref="formRef">
          <el-form-item label="发送邮箱账号" prop="email">
            <el-input v-model="formData.email" placeholder="请输入发送邮箱账号" />
          </el-form-item>
          <el-form-item label="发送邮箱密码" prop="password">
            <el-input 
              v-model="formData.password" 
              type="password" 
              placeholder="请输入发送邮箱密码" 
              show-password
            />
          </el-form-item>
          <el-form-item label="测试收件人" prop="testRecipient">
            <el-input v-model="formData.testRecipient" placeholder="请输入测试收件人邮箱" />
          </el-form-item>
          <el-form-item label="是否启用" prop="status">
            <el-switch 
              v-model="formData.status" 
              :active-value="1" 
              :inactive-value="0"
            />
          </el-form-item>
        </el-form>
        
        <div class="dialog-tip">
          <el-alert
            title="保存前先测试，发送邮箱账号密码错误将导致用户无法收发邮件"
            type="warning"
            :closable="false"
            show-icon
          />
        </div>
      </div>
      
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="info" @click="testEmail" :loading="testLoading">测试</el-button>
          <el-button type="primary" @click="submitForm" :loading="submitLoading">确定</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { ref, computed, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import {
  Refresh,
  Grid,
  Setting,
  Box
} from "@element-plus/icons-vue";
import { 
  getEmailConfigs, 
  saveEmailConfig, 
  updateEmailConfig, 
  deleteEmailConfig as deleteEmailConfigApi,
  testEmailSending 
} from "@/api/email";

export default {
  name: "OtherConfigPage",
  components: {
    Refresh,
    Grid,
    Setting,
    Box
  },
  setup() {
    // 用户角色
    const userRole = ref(0);
    
    // 表格相关
    const tableData = ref([]);
    const rowHeight = ref("80px");
    const densityDialogVisible = ref(false);
    const columnsDialogVisible = ref(false);
    
    // 列配置
    const columns = [
      { prop: "id", label: "序号", minWidth: "80", align: "center" },
      { prop: "email", label: "邮箱账号", minWidth: "200" },
      { prop: "password", label: "邮箱密码", minWidth: "150" },
      { prop: "status", label: "状态", minWidth: "100", align: "center" },
      { prop: "createTime", label: "创建时间", minWidth: "180" },
      { prop: "operation", label: "操作", minWidth: "150", align: "center" }
    ];
    
    const selectedColumns = ref(columns.map(col => col.prop));
    const tempSelectedColumns = ref([...selectedColumns.value]);
    
    const visibleColumns = computed(() => {
      let filteredColumns = columns.filter(col => selectedColumns.value.includes(col.prop));
      // 非管理员不显示操作列
      if (userRole.value !== 0) {
        filteredColumns = filteredColumns.filter(col => col.prop !== 'operation');
      }
      return filteredColumns;
    });
    
    // 弹窗相关
    const dialogVisible = ref(false);
    const dialogTitle = ref("");
    const isEdit = ref(false);
    const testLoading = ref(false);
    const submitLoading = ref(false);
    
    const formData = ref({
      id: null,
      email: "",
      password: "",
      testRecipient: "",
      status: 1
    });
    
    const formRef = ref(null);
    
    // 表单验证规则
    const rules = {
      email: [
        { required: true, message: "请输入发送邮箱账号", trigger: "blur" },
        { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" }
      ],
      password: [
        { required: true, message: "请输入发送邮箱密码", trigger: "blur" }
      ],
      testRecipient: [
        { type: "email", message: "请输入正确的邮箱格式", trigger: "blur" }
      ]
    };
    

    
    // 方法
    
    const getRowStyle = () => {
      return { height: rowHeight.value };
    };
    
    const setRowHeight = (height) => {
      rowHeight.value = height;
      densityDialogVisible.value = false;
    };
    
    const tableRowClassName = ({ rowIndex }) => {
      return rowIndex % 2 === 1 ? "stripe-row" : "";
    };
    
    const resetColumns = () => {
      tempSelectedColumns.value = columns.map(col => col.prop);
    };
    
    const confirmColumns = () => {
      selectedColumns.value = [...tempSelectedColumns.value];
      columnsDialogVisible.value = false;
    };
    
    const refreshData = async () => {
      try {
        const response = await getEmailConfigs();
        if (response.success) {
          tableData.value = response.data || [];
        }
      } catch (error) {
        ElMessage.error("获取邮箱配置失败");
      }
    };
    
    const openAddDialog = () => {
      dialogTitle.value = "新增邮箱配置";
      isEdit.value = false;
      formData.value = {
        id: null,
        email: "",
        password: "",
        testRecipient: "",
        status: 1
      };
      dialogVisible.value = true;
    };
    
    const editEmailConfig = (row) => {
      dialogTitle.value = "编辑邮箱配置";
      isEdit.value = true;
      formData.value = {
        id: row.id,
        email: row.email,
        password: row.password || "",
        testRecipient: "",
        status: row.status
      };
      dialogVisible.value = true;
    };
    
    const closeDialog = () => {
      dialogVisible.value = false;
      formRef.value?.resetFields();
    };
    
    const testEmail = async () => {
      if (!formRef.value) return;
      
      // 检查测试收件人邮箱是否为空
      if (!formData.value.testRecipient || formData.value.testRecipient.trim() === '') {
        ElMessage.warning('请输入测试收件人邮箱');
        return;
      }
      
      try {
        await formRef.value.validateField(['email', 'password', 'testRecipient']);
        
        testLoading.value = true;
        const testData = {
          senderEmail: formData.value.email,
          senderPassword: formData.value.password,
          recipientEmail: formData.value.testRecipient
        };
        
        const response = await testEmailSending(testData);
        if (response.success) {
          ElMessage.success("发送成功，请注意收件人邮箱");
        } else {
          ElMessage.error(response.message || "测试邮件发送失败");
        }
      } catch (error) {
        if (typeof error === 'string') {
          return; // 表单验证错误
        }
        ElMessage.error("测试邮件发送失败");
      } finally {
        testLoading.value = false;
      }
    };
    
    const submitForm = async () => {
      if (!formRef.value) return;
      
      try {
        await formRef.value.validate();
        
        submitLoading.value = true;
        let submitData;
        let response;
        
        if (isEdit.value) {
          submitData = {
            id: formData.value.id,
            email: formData.value.email,
            password: formData.value.password,
            status: formData.value.status
          };
          response = await updateEmailConfig(submitData);
        } else {
          submitData = {
            email: formData.value.email,
            password: formData.value.password,
            status: formData.value.status
          };
          response = await saveEmailConfig(submitData);
        }
        
        if (response.success) {
          ElMessage.success("保存成功");
          closeDialog();
          refreshData();
        } else {
          ElMessage.error(response.message || "保存失败");
        }
      } catch (error) {
        ElMessage.error("保存失败");
      } finally {
        submitLoading.value = false;
      }
    };
    
    const deleteEmailConfig = async (email) => {
      try {
        await ElMessageBox.confirm(
          "确定要删除这个邮箱配置吗？",
          "确认删除",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        );
        
        const response = await deleteEmailConfigApi(email);
        if (response.success) {
          ElMessage.success("删除成功");
          refreshData();
        } else {
          ElMessage.error(response.message || "删除失败");
        }
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error("删除失败");
        }
      }
    };
    


    // 格式化日期时间
    const formatDateTime = (dateTimeStr) => {
      if (!dateTimeStr) return '-';
      // 处理ISO格式的时间字符串，如2025-06-22T01:18:25.089983
      const date = new Date(dateTimeStr);
      if (isNaN(date.getTime())) return dateTimeStr; // 如果日期无效，返回原字符串
      
      // 格式化为 年-月-日 时:分:秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    // 初始化
    onMounted(() => {
      const userInfo = localStorage.getItem('userInfo');
      if (userInfo) {
        const user = JSON.parse(userInfo);
        userRole.value = user.role || 0;
      }
      refreshData();
    });
    
    return {
      userRole,
      tableData,
      rowHeight,
      densityDialogVisible,
      columnsDialogVisible,
      columns,
      selectedColumns,
      tempSelectedColumns,
      visibleColumns,
      dialogVisible,
      dialogTitle,
      isEdit,
      testLoading,
      submitLoading,
      formData,
      formRef,
      rules,
      getRowStyle,
      setRowHeight,
      tableRowClassName,
      resetColumns,
      confirmColumns,
      refreshData,
      openAddDialog,
      editEmailConfig,
      closeDialog,
      testEmail,
      submitForm,
      deleteEmailConfig,
      formatDateTime
    };
  }
};
</script>

<style scoped>
.other-config {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.email-config-content {
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  box-sizing: border-box;
}

.data-section {
  background: white;
  width: 100%;
  overflow-x: auto;
}

.toolbar {
  display: flex;
  gap: 10px;
  align-items: center;
}

.popover-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.density-button {
  width: 100%;
  justify-content: flex-start;
}

.popover-footer {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.operation-buttons {
  display: flex;
  gap: 8px;
  justify-content: center;
}

.empty-state {
  text-align: center;
  padding: 40px;
  color: #999;
}

.empty-icon {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 14px;
  margin: 0;
}

.custom-dialog .dialog-content {
  padding: 0 20px;
}

.dialog-tip {
  margin-top: 20px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

:deep(.stripe-row) {
  background-color: #fafafa;
}

:deep(.el-table__row:hover) {
  background-color: #f5f7fa;
}


</style>